import {
	ORDERLOCATIONS,
	ORDERLOCATIONS_LIST_SUCCESSFUL,
	ORDERLOCATIONS_ADD,
	ORDERLOCATIONS_ADD_SUCCESSFUL,
	ORDERLOCATIONS_DELETE,
	ORDERLOCATIONS_SET_ROW_DATA,
	ORDERLOCATIONS_SET_EDIT_DATA,
	MODEL_OPEN,
	MODEL_CLOSE,
	API_ERROR,
	SET_PARAMS,
	SELECT_CHANGEVALUE,
	INPUT_CHANGEVALUE,
	LOCATION_IMAGE,
	GET_Location_ROW_DATA,
	Location_ROW_SUCCESSFUL,
	CLEAR_ORDERLOCATION_DATA,
	ORDERLOCATIONS_EDIT_SUCCESSFUL,
	ORDERLOCATIONS_EDIT,
} from "./actionTypes";

export const getORDERLocations = (data) => ({
	type: ORDERLOCATIONS,
	payload: { data },
});

export const LocationImage = (image) => {
	return {
		type: LOCATION_IMAGE,
		payload: { image },
	};
};
export const ORDERlocationListSuccessful = (locations) => ({
	type: ORDERLOCATIONS_LIST_SUCCESSFUL,
	payload: locations,
});

export const SelecteChangeValue = ({ key, label, key2, value }) => ({
	type: SELECT_CHANGEVALUE,
	payload: { key, label, key2, value },
});

export const InputChangeValue = ({ key, value }) => ({
	type: INPUT_CHANGEVALUE,
	payload: { key, value },
});

export const ORDERlocationEdit = (data) => {
	return {
		type: ORDERLOCATIONS_EDIT,
		payload: data,
	};
};

export const ORDERlocationEditSuccessful = (response) => {
	return {
		type: ORDERLOCATIONS_EDIT_SUCCESSFUL,
		payload: response,
	};
};

export const ORDERlocationAdd = ({
	data,
	image,
	fileType,
	LoId,
	history,
	model,
}) => ({
	type: ORDERLOCATIONS_ADD,
	payload: { data, image, fileType, LoId, history, model },
});

// export const ORDERlocationAdd = ({ data, image, LoId, history, model }) => ({
// 	type: ORDERLOCATIONS_ADD,
// 	payload: { data, image, LoId, history, model },
// });

export const locationAddSuccessful = (response) => ({
	type: ORDERLOCATIONS_ADD_SUCCESSFUL,
	payload: response,
});

export const ORDERlocationRowData = (LocId) => ({
	type: ORDERLOCATIONS_SET_ROW_DATA,
	payload: { LocId },
});

export const getOrderLocationRowData = (id, history) => {
	return {
		type: GET_Location_ROW_DATA,
		payload: { LocId: id, history },
	};
};

export const locationRowDataSuccessful = (response) => ({
	type: Location_ROW_SUCCESSFUL,
	payload: response,
});

export const SetEditData = (data) => ({
	type: ORDERLOCATIONS_SET_EDIT_DATA,
	payload: data,
});

export const ORDERlocationDelete = (locId) => ({
	type: ORDERLOCATIONS_DELETE,
	payload: { locId },
});

export const model_open = () => ({
	type: MODEL_OPEN,
});

export const model_close = () => ({
	type: MODEL_CLOSE,
});

export const SetParams = (params) => ({
	type: SET_PARAMS,
	payload: params,
});

export const apiError = (error) => ({
	type: API_ERROR,
	payload: error,
});

export const clearOrderLocationData = () => {
	return {
		type: CLEAR_ORDERLOCATION_DATA,
	};
};
